//Реакт
import React from "react";
//Стили
import './styles.css';

export default function Label({children, ...other}){
    return <label className="label" {...other}>{children}</label>
}